import React from 'react';
import { Row, Col, FormGroup, Card } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import { useSelector } from 'react-redux';
import { set } from 'lodash';
import { useTranslation } from 'react-i18next';
import { usePurchaseOrderState } from '../PurchaseOrderContext';
import CustomDatePicker from '../../../../Components/Utility/DatePicker/DatePicker';
import { imageUrl } from '../../../../Components/helper';

export function RenderPurchaseOrderDetail() {
  const {
    purchaseOrderData: { purchaseOrderDetails },
    BOMConfigDetails: { productDetails },
  } = useSelector((reduxState) => reduxState);
  const {
    purchaseOrderState: { poOrderNo, poSelectedDate },
    setPurchaseOrderState,
    purchaseOrderState,
    disableConditions,
    fromPreview,
    isPublicPoPage,
    previewData,
    poAddEditAccess,
  } = usePurchaseOrderState();
  const { t } = useTranslation('common');

  const handleSelectChange = (value, path) => {
    const copyState = purchaseOrderState;
    set(purchaseOrderState, path, value);
    setPurchaseOrderState((prevState) => ({ ...prevState, ...copyState }));
  };

  const imgSrc = () => {
    return fromPreview || isPublicPoPage ? previewDataImage() : poDetails();
  };

  const local = JSON.parse(localStorage.getItem('loggedInUserInfo'));

  const hasLogo = () => {
    return local?.companyLogo ? `${imageUrl}/${local?.companyLogo}` : '';
  };

  const handlings3Image = () => {
    return local?.companyLogo?.includes('s3.eu-west-2') ? local?.companyLogo : hasLogo();
  };
  const handleSuperAdminLogo = () => {
    return local?.companyLogo?.includes('super-admin')
      ? `https://${process.env.REACT_APP_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${local?.companyLogo}`
      : handlings3Image();
  };

  const poDetails = () => {
    if (purchaseOrderDetails?.image?.includes('s3.eu-west-2')) {
      return purchaseOrderDetails?.image;
    }
    if (purchaseOrderDetails?.image) {
      return `${imageUrl}/${purchaseOrderDetails?.image}`;
    }
    return handleSuperAdminLogo();
  };

  const previewDataImage = () => {
    if (previewData?.image?.includes('s3.eu-west-2')) {
      return previewData?.image;
    }
    if (previewData?.image) {
      return `${imageUrl}/${previewData?.image}`;
    }
    return handleSuperAdminLogo();
  };

  function SelectedDate() {
    return poSelectedDate ? new Date(poSelectedDate) : null;
  }

  const hasDate = (element) => {
    return element ? new Date(element) : null;
  };

  return (
    <Card className="listing-card pt-1">
      <Card.Body>
        <Row className="span_font_size">
          <Col lg={6} className="company-logo-block">
            <figure>
              <img src={imgSrc()} alt="" />
            </figure>
          </Col>
          <Col lg={6}>
            <h4 className="mt-3 mb-2">{t('PURCHASE_ORDER_NUMBER.PURCHASE_ORD')}</h4>
            <Row>
              <Col lg={6}>
                <div className="input-group form-floating-label-poDesc fixed-label">
                  <label className="asterisk-req f-14">{t('PURCHASE_ORDER_NUMBER.ORDER_NUMBER')}</label>
                  <input
                    type="text"
                    value={poOrderNo}
                    className="form-control f-14"
                    disabled
                    onChange={(e) => handleSelectChange(e.target.value, 'poOrderNo')}
                  />
                </div>
              </Col>
              <Col lg={6}>
                <FormGroup>
                  <label className="text-label mb-0 asterisk-req f-14">{t('PURCHASE_ORDER_NUMBER.PURCHASE_DATE')}</label>
                  <div className="date">
                    <div className="input-button-container">
                      <CustomDatePicker
                        dateFormat="dd-MMM-yyyy"
                        valueProp={previewData ? hasDate(previewData?.poSelectedDate) : SelectedDate()}
                        name="selectedActualApproveByDate"
                        placeholder={t('PURCHASE_ORDER_NUMBER.PURCHASE_DATE')}
                        onChange={(date) => handleSelectChange(date, 'poSelectedDate')}
                        disable
                        popperPlace="bottom-end"
                      />
                    </div>
                  </div>
                </FormGroup>
              </Col>
            </Row>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}

export default RenderPurchaseOrderDetail;
